module.exports = __webpack_public_path__ + "img/gorilla.7ee4121d.png";